import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Swoosh = ({skew, color, active}) => {
    return (
        <div className={classNames('swoosh', `skew-${skew}`, active && 'active')}>
            <div className={`swoosh-${color}`} />
        </div>
    )
};

Swoosh.propTypes = {
    skew: PropTypes.string,
    color: PropTypes.string,
    active: PropTypes.bool
};

Swoosh.defaultProps = {
    skew: 'left',
    color: 'blue',
    active: false
};

export default Swoosh;
